// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_kq-6";
export var emphasizeQuantity = "_kq-3";
export var flatBottomCorners = "_kq-5";
export var productImage = "_kq-0";
export var quantityContainer = "_kq-2";
export var tooltip = "_kq-1";
export var wrapAndEllipsesOverflow = "_kq-4";